module.exports = __webpack_public_path__ + "static/media/26UNRWA21.a1109566.jpg";